<div class="mt-3">
    <mat-form-field class="w-100">
        <mat-label>Filter</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Ex. ium" #input>
    </mat-form-field>

    <table mat-table [dataSource]="dataSource" matSort matSortActive="allTimeRevaPoints" matSortDirection="desc"
        class="mat-elevation-z8">

        <ng-container matColumnDef="imgURL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> IMG</th>
            <td mat-cell *matCellDef="let element" class="img-container"><img src="{{ element.imgURL }}" class="img-thumbnail rounded-pill" onerror="this.src='assets/img/user_default.png'"> </td>
        </ng-container>
        
        <ng-container matColumnDef="batchId">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Batch ID </th>
            <td mat-cell *matCellDef="let element"> {{element.batchId}} </td>
        </ng-container>

        <ng-container matColumnDef="allTimeRevaPoints">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> All Time RevaPoints </th>
            <td mat-cell *matCellDef="let element"> {{element.allTimeRevaPoints}} </td>
        </ng-container>

        <ng-container matColumnDef="currentRevaPoints">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Current RevaPoints </th>
            <td mat-cell *matCellDef="let element"> {{element.currentRevaPoints}} </td>
        </ng-container>

        <ng-container matColumnDef="fname">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> First name </th>
            <td mat-cell *matCellDef="let element"> {{element.fname}} </td>
        </ng-container>

        <ng-container matColumnDef="lname">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Last name </th>
            <td mat-cell *matCellDef="let element"> {{element.lname}} </td>
        </ng-container>

        <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Action </th>
            <td mat-cell *matCellDef="let element"> <button mat-button color='accent' (click)="actionEvent.emit(element.employeeId)">{{actionType}}</button> </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns" ></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
</div>